import React from "react";

import range from "lodash/range";

function SkeletonLoader() {
	return (
		<div className="loader--skeleton loader--skeleton--content loader--skeleton--nav-secondary">
			{range(1, 11).map((i) => (
				<div key={i} className="loader--skeleton__item">
					<div className="loader--skeleton__icon loader--skeleton__icon--med" />
					<div className="loader--skeleton__title loader--skeleton__title--med" />
				</div>
			))}
		</div>
	);
}

export default SkeletonLoader;
